import {
  type AcademyAdditionalDataBody,
  academyApi,
  type AcademyInitializationBody,
  type AcademyInitializationUpdateBody,
  type AcademyMetadataItemBody,
  type AcademyUpdateBody,
  type FreePremiumBody,
  type NiceEncodeInfoParams,
} from '@mathflat/domain/Academy'
import { podSettlementApi } from '@mathflat/domain/PodSettlement'

import { mpEventInfo } from '@/constant'
import { Academy } from '@/dto'
import commonRepo from '@/repository/common.repo'

class AcademyController {
  async fetchMyAcademy() {
    const academy = await academyApi.getAcademyDetail({
      mp_event_name: mpEventInfo.학원정보가져오기,
    })
    return new Academy(academy)
  }

  async changeMyAcademy(academy: Academy) {
    await academyApi.updateAcademy(
      {
        name: academy.name,
        email: academy.email,
        address: academy.address,
        addressDetail: academy.addressDetail,
        zipCode: academy.zipCode,
      },
      { mp_event_name: mpEventInfo.학원정보수정 },
    )
  }

  async changeMyAcademyLogo(form: FormData) {
    await academyApi.updateAcademyLogo(form, { mp_event_name: mpEventInfo.로고수정 })
  }

  // 고객 정보 수정과 같은 요청이지만 4주간만 띄우는 고객 분류 팝업이 분류만 보낸다
  async changeCustomerType(body: Pick<AcademyUpdateBody, 'customerType'>) {
    await academyApi.updateAcademy(body, { mp_event_name: mpEventInfo.학원정보수정 })
  }

  async getNiceEncodeInfo(params: NiceEncodeInfoParams) {
    return academyApi.getNiceEncodeData(params, { mp_event_name: mpEventInfo.SMS핸드폰인증 })
  }

  async registerSmsPhoneNumberByNice(encodeData: string) {
    await academyApi.registerSmsPhoneNumberByNice(encodeData, {
      mp_event_name: mpEventInfo.NICE인증발신번호등록,
    })
  }

  async fetchNiceIdentityForSettlement(encodeData: string) {
    return academyApi.getNiceIdentityForSettlement(encodeData, {
      mp_event_name: mpEventInfo.NICE인증발신번호등록,
    })
  }

  postMetaData = async (body: AcademyInitializationBody) => {
    await academyApi.initializeAcademy(body, { mp_event_name: mpEventInfo.내정보수정 })
  }
  patchMetaData = async (body: AcademyMetadataItemBody) => {
    await academyApi.updateAcademyMetadataItem(body, {
      mp_event_name: mpEventInfo.학원메타데이터수정,
    })
  }
  refetchAfterPutMetaData = async (body: AcademyInitializationUpdateBody) => {
    await academyApi.updateAcademyInitialization(body, {
      mp_event_name: mpEventInfo.학원메타데이터수정,
    })
    commonRepo.academy = await this.fetchMyAcademy()
  }

  postFreePremium = async (body: FreePremiumBody) => {
    await academyApi.requestFreePremium(body, { mp_event_name: mpEventInfo.프리미엄체험신청 })
  }

  getSettlementWithIdentification = async () => await podSettlementApi.getSettlementAccount()

  putAdditionalData = async (body: AcademyAdditionalDataBody) => {
    await academyApi.updateAcademyAdditionalData(body, { mp_event_name: mpEventInfo.학원정보수정 })
  }

  postSubscriptionOffer = async (
    ...params: Parameters<typeof academyApi.requestSubscriptionOffer>
  ) => {
    await academyApi.requestSubscriptionOffer(...params)
  }
}

export const academyController = new AcademyController()
